export class ReprintModel {
  OriginalOrderlineId: string;
  ReprintReason: string;
  ReprintReasonId: number;
  ReprintQuantity: number;
  ShouldBeZeroedOut: boolean;
  IsVisibleInUI: boolean;

  constructor() {
    this.OriginalOrderlineId = '';
    this.ReprintQuantity = 0;
    this.ReprintReason = 'N/A';
    this.ReprintReasonId = 0;
    this.ShouldBeZeroedOut = true;
    this.IsVisibleInUI = true;
  }
}
